import FooterProvider from './hooks/useFooter';

import { FooterProps } from './@types/FooterProps';
import FooterLayout from './handles/FooterLayout';

const Desktop = (props: FooterProps) => (
	<FooterProvider {...props}>
		<FooterLayout blockClass={props.blockClass}>{props.children}</FooterLayout>
	</FooterProvider>
);

const Mobile = (props: FooterProps) => (
	<FooterProvider {...props}>
		<FooterLayout>{props.children}</FooterLayout>
	</FooterProvider>
);

export const Footer = { Desktop, Mobile };
